var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecorativeTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_185338",
    "data-name": "Group 185338",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.175,
    height: 25.781,
    viewBox: "0 0 18.175 25.781",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2495",
    "data-name": "Rectangle 2495",
    width: 18.175,
    height: 25.781,
    fill: "#7119bf",
    stroke: "#fff",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_185338-2",
    "data-name": "Group 185338",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_847",
    "data-name": "Path 847",
    d: "M149.8,182.1a1.427,1.427,0,0,1-1.06-1.069,1.371,1.371,0,0,1,1.03-1.653,4.136,4.136,0,0,0,2.076-1.349,4.328,4.328,0,0,0,.95-2.532,11.142,11.142,0,0,1-1.465-.142,3.885,3.885,0,0,1-2.967-4.458c.116-.711.2-1.427.315-2.138a1.372,1.372,0,0,1,1.59-1.153,1.4,1.4,0,0,1,1.139,1.587c-.1.714-.2,1.426-.306,2.139a1.139,1.139,0,0,0,.9,1.348,1.182,1.182,0,0,0,1.351-1.019c.142-.944.274-1.89.408-2.835a1.386,1.386,0,0,1,1.563-1.225,1.353,1.353,0,0,1,1.175,1.524c-.114,1-.269,1.992-.412,2.987-.211,1.467-.391,2.94-.649,4.4a6.693,6.693,0,0,1-4.786,5.495c-.086.029-.17.063-.254.095Z",
    transform: "translate(-138.344 -156.324)",
    fill: "#7119bf",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    "data-name": "Path 848",
    d: "M5.018,8.573c-.136-.006-.243-.015-.35-.016-1.057,0-2.114,0-3.171,0A1.4,1.4,0,0,1,.1,7.677,1.375,1.375,0,0,1,1.385,5.791c2.542,0,5.084,0,7.627,0A1.518,1.518,0,0,0,10.56,4.7,1.5,1.5,0,0,0,9.205,2.774a2.755,2.755,0,0,1-.62-.081,1.369,1.369,0,0,1-.953-1.547A1.383,1.383,0,0,1,8.972,0,4.272,4.272,0,0,1,9.5,8.527c-.477.031-.956.028-1.433.026-.167,0-.239.056-.263.221q-.428,2.947-.864,5.892c-.154,1.044-.3,2.089-.464,3.132A1.381,1.381,0,0,1,5.1,19.048,1.339,1.339,0,0,1,3.727,17.86a4.2,4.2,0,0,1,.087-1.046Q4.4,12.837,5,8.861c.012-.082.012-.166.02-.289",
    transform: "translate(0 0)",
    fill: "#7119bf",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecorativeTool);
export default __webpack_public_path__ + "static/media/decorative_tool.3a73278e766881f6aaea4518ecab2b68.svg";
export { ForwardRef as ReactComponent };